import React, { Fragment, useEffect, useState } from "react";
import useEmpLTP from "./useEmpLTP";
import {
  MainWrapper,
  PrimaryTab,
  PrimaryTabs,
  PrimaryTabsWrapper,
  StyledDivider,
  SubTab,
  SubTabs,
  SubTabsWrapper,
} from "../../citizen/AVPForms/components/StyledComponent";
import {
  BackButton,
  BreakLine,
  Card,
  CardSectionHeader,
  CheckPoint,
  ConnectingCheckPoints,
  Loader,
  Toast,
} from "@egovernments/digit-ui-react-components";
import FormStrip from "../../citizen/AVPForms/components/FormStrip";
import SubStep1 from "../../citizen/AVPForms/formComponents/ltp-registration/Step1/SubStep1";
import SubStep2 from "../../citizen/AVPForms/formComponents/ltp-registration/Step1/SubStep2";
import SubStep3 from "../../citizen/AVPForms/formComponents/ltp-registration/Step1/SubStep3";
import SubStep4 from "../../citizen/AVPForms/formComponents/ltp-registration/Step1/SubStep4";
import SubStep5 from "../../citizen/AVPForms/formComponents/ltp-registration/Step1/SubStep5";
import { useTranslation } from "react-i18next";
import RecommendationRemarksComponent from "../RecommendationComponent";
import { siteInspRecommendation } from "../../citizen/TCPForms/data";
import ViewDocuments from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/ViewDocuments";
import ViewSidebarIcon from "@mui/icons-material/ViewSidebar";
import { Button } from "@mui/material";
// import PrimaryContent from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/PrimaryContent";
import EmployeeComponent from "../../../../../templates/ApplicationDetails/RoleAccessProfessional/Employer";
import OnSelectActionDropdown from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/OnSelectActionDropdown";
import RemarksEditor from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/RemarksEditor";
import DocUploader from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/DocUploader";
import SubmitButton from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/SubmitButton";
import TLCaption from "../../../../../templates/ApplicationDetails/components/TLCaption";
import LTPCheckList from "../../citizen/TCPForms/formComponents/registration/LTPChecklist";
import AllRemarksList from "../../../../../templates/Forms/AllRemarks";
import Architect from "../../../../../templates/ApplicationDetails/RoleAccessProfessional/Architect";
import DocumentSection from "../PurchasableFAR/DocumentSection";
// import DetailInfoTable from "../AllViewRemarks";
import DocumentSectionLog from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/DocumentSectionLog";
import DscLetters from "../DigitalSignLetters";
import InputWrapper from "../../citizen/AVPForms/layout/inputWrapper";
import { useForm } from "react-hook-form";

const EmpLtpPortal = ({ applicationDetails, workflowDetails, isDataLoading, timelineStatusPrefix, statusAttribute = "status" }) => {
  const formData = applicationDetails?.applicationData;

  const {
    subTabLabels,
    tradeType,
    isCitizen,
    params,
    setParams,
    clearParams,
    onSelect,
    updateApiCall,
    currentAction,
    setCurrentAction,
    developerRemarks,
    setDeveloperRemarks,
    uploadedFile,
    setUploadedFile,
    handleNoWorkflow,
    applicationDocs,
    totalAmount,
    actions,
    onDropDownSelect,
    handleSubmit,
    viewApprovalLetter,
    showTakeAction,
    iframeSrc,
    setIframeSrc,
    updatedDocuments,
    setUpdatedDocuments,
    dataRecommendationDocument,
    setDataRecommendationDocument,
    developerRemarksDocument,
    setDeveloperRemarksDocument,
    callDocumentDetailsAPI,
    documentRemarksData,
    setValidUpto,
    fiveYearsFromNow,
  } = useEmpLTP(formData, workflowDetails);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [currentView, setCurrentView] = useState("documents");
  const [remarks, setRemarks] = useState("");
  const [error, setError] = useState(false);
  const [activeTab, setActiveTab] = useState(Digit?.SessionStorage.get("REGISTRATION_CURRENT_TAB") || 0);
  const [selectedSubTab, setSelectedSubTab] = useState(Digit?.SessionStorage.get("REGISTRATION_CURRENT_SUBTAB") || 0);
  const defaultValues = { validupto: formData?.validupto || "" };
  const { control, getValues, watch } = useForm({ defaultValues });
  const { t } = useTranslation();
  const validUpTo = watch("validupto");
  const attachedDocs = params?.tradeLicenseDetail?.applicationDocuments || formData?.tradeLicenseDetail?.applicationDocuments;
  console.log("loggingLTPDataaaa", formData, attachedDocs);

  const handleTabChange = (nextTabNo, formData = null) => {
    setActiveTab(nextTabNo);
    Digit.SessionStorage.set("REGISTRATION_CURRENT_TAB", nextTabNo);
  };
  const handleSubTabChange = (nextSubTab, formData = null) => {
    setSelectedSubTab(nextSubTab);
    Digit.SessionStorage.set("REGISTRATION_CURRENT_SUBTAB", nextSubTab);
  };
  const handleDocView = () => {
    setCurrentView((prev) => (prev === "documents" ? "viewDocuments" : "documents"));
  };
  function OpenImage(imageSource, index, thumbnailsToShow) {
    window.open(thumbnailsToShow?.fullImage?.[0], "_blank");
  }
  const getTimelineCaptions = (checkpoint) => {
    if (checkpoint.state === "OPEN" || (checkpoint.status === "INITIATED" && !window.location.href.includes("/obps/"))) {
      const caption = {
        date: Digit.DateUtils.ConvertTimestampToDate(applicationData?.auditDetails?.createdTime),
        source: applicationData?.channel || "",
      };
      return <TLCaption data={caption} />;
    } else if (window.location.href.includes("/obps/") || window.location.href.includes("/noc/")) {
      const caption = {
        date: checkpoint?.auditDetails?.lastModified,
        name: checkpoint?.assignes?.[0]?.name,
        mobileNumber: checkpoint?.assignes?.[0]?.mobileNumber,
        comment: t(checkpoint?.comment),
        wfComment: checkpoint.wfComment,
        thumbnailsToShow: checkpoint?.thumbnailsToShow,
      };
      return <TLCaption data={caption} OpenImage={OpenImage} />;
    } else {
      const caption = {
        date: Digit.DateUtils?.ConvertTimestampToDate(applicationData?.auditDetails?.lastModifiedTime),
        name: checkpoint?.assignes?.[0]?.name,
        wfComment: checkpoint?.wfComment,
        mobileNumber: checkpoint?.assignes?.[0]?.mobileNumber,
      };
      return <TLCaption data={caption} />;
    }
  };

  const renderContent = () => {
    if (activeTab === 0) {
      switch (selectedSubTab) {
        case 0:
          return <SubStep1 formData={formData} handleSubTabChange={handleSubTabChange} isEmployee={!isCitizen} />;
        case 1:
          return <SubStep2 formData={formData} handleSubTabChange={handleSubTabChange} isEmployee={!isCitizen} />;
        case 2:
          return <SubStep3 formData={formData} handleSubTabChange={handleSubTabChange} isEmployee={!isCitizen} />;
        case 3:
          return <SubStep4 formData={formData} handleSubTabChange={handleSubTabChange} isEmployee={!isCitizen} />;

        default:
          return null;
      }
    } else if (activeTab === 1 && !isCitizen) {
      return (
        <React.Fragment>
          {" "}
          <div className="view-doc-container">
            <Button
              variant="contained"
              className="view-doc-btn"
              onClick={handleDocView}
              style={{ backgroundColor: "#157C4F", borderRadius: "15px", padding: "5px 10px" }}
            >
              <span className="view-doc-icon">
                <ViewSidebarIcon />
              </span>
              {currentView === "documents" ? "View all documents" : "View document section"}
            </Button>
          </div>
          {currentView === "documents" ? (
            <React.Fragment>
              <DocumentSection
                formData={params}
                handleChange={handleTabChange}
                setUpdatedDocuments={setUpdatedDocuments}
                updatedDocuments={updatedDocuments}
                setIsPreviewLoading={setIsPreviewLoading}
                setDataRecommendation={setDataRecommendationDocument}
                onSelect={onSelect}
                handleNoWorkflow={handleNoWorkflow}
                attachedDocs={attachedDocs}
                docType="mandatory"
                detailData={documentRemarksData?.DetailDataRemarks}
                developerRemarks={developerRemarksDocument}
                setError={setError}
                setDeveloperRemarks={setDeveloperRemarksDocument}
                callDocumentDetailsAPI={callDocumentDetailsAPI}
                ComposableComponent={(props) => (
                  <RecommendationRemarksComponent
                    title="Recommendation Details"
                    label="Recommendation"
                    name="recommendation" // just a field name, not value!
                    options={siteInspRecommendation}
                    defaultValue={dataRecommendationDocument}
                    extraLabel="Remarks"
                    setDeveloperRemarks={setDeveloperRemarksDocument}
                    developerRemarks={developerRemarksDocument}
                    setDataRecommendation={setDataRecommendationDocument}
                    error={error}
                    setError={setError}
                    // onSaveClick={callDocumentDetailsAPI}
                    {...props} // this includes `control`, injected later
                  />
                )}
              />
              {!isCitizen && (
                <>
                  {/* <DetailInfoTable detailData={documentRemarksData?.DetailDataRemarks} type="documentDetails" /> */}
                  <DocumentSectionLog logData={documentRemarksData?.DetailDataRemarks} />
                </>
              )}{" "}
            </React.Fragment>
          ) : (
            <ViewDocuments
              documentSection={attachedDocs}
              setIsPreviewLoading={setIsPreviewLoading}
              iframeSrc={iframeSrc}
              setIframeSrc={setIframeSrc}
            />
          )}
        </React.Fragment>
      );
    } else if (activeTab === 1 && isCitizen) {
      {
        return (
          <React.Fragment>
            <Architect formData={formData} applicationDocs={applicationDocs} totalAmount={totalAmount} actions={actions} />
            {(formData?.status === "APPROVED" || showTakeAction === "Take_Action") && (
              <div style={{ marginLeft: "180px", marginTop: "20px" }}>
                <Button
                  variant="contained"
                  color="success"
                  style={{ marginLeft: "10px" }}
                  onClick={() => viewApprovalLetter(formData?.approvalLetterUrl)}
                >
                  View Approval Letter
                </Button>
              </div>
            )}
          </React.Fragment>
        );
      }
    } else if (activeTab === 2 && !isCitizen) {
      return (
        <React.Fragment>
          <LTPCheckList formData={formData} />
        </React.Fragment>
      );
    } else if (activeTab === 2 && isCitizen) {
      return (
        <React.Fragment>
          <AllRemarksList remarkDataResps={workflowDetails?.data} formData={formData} />
        </React.Fragment>
      );
    } else if (activeTab === 3) {
      return (
        <React.Fragment>
          {" "}
          <EmployeeComponent formData={formData} applicationDocs={applicationDocs} />
          {formData?.status === "APPLY_FOR_DSC" && (
            <DscLetters formData={formData} handleChange={handleTabChange} isEmployee={!isCitizen} viewDrawing={false} pdfType={"LTP"} />
          )}
          {formData?.status !== "APPROVED" && (
            <div className="valid-upto-input-container">
              {" "}
              <OnSelectActionDropdown currentAction={currentAction || " "} onChange={onDropDownSelect} actions={actions} />
              <div className="valid-upto-input">
                Valid Up To *
                <InputWrapper
                  // label={t("Valid Up To")}
                  hasLabel={false}
                  mandatory
                  control={control}
                  placeholder="Select Date"
                  name="validupto"
                  disablePast={true}
                  // defaultValue={formData?.tradeLicenseDetail?.owners?.[0]?.dateOfBirth}
                  // disabled={isEmployee || (isReapply && formData?.tradeLicenseDetail?.owners?.[0]?.dateOfBirth)}
                  type="datePicker"
                  maxDate={fiveYearsFromNow}
                  // disableFuture={true}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Date"),
                      message: "Please enter valid date",
                    },
                  }}
                />
              </div>
            </div>
          )}
          {formData?.status !== "APPROVED" && (
            <RemarksEditor setRemarks={setDeveloperRemarks} remarks={developerRemarks} setError={setError} error={error} />
          )}
          {formData?.status !== "APPROVED" && <DocUploader uploadedFile={uploadedFile} setUploadedFile={setUploadedFile} />}
          {formData?.status !== "APPROVED" && <SubmitButton handleSubmit={handleSubmit} isLoading={updateApiCall.isLoading} />}
          {/* {(formData?.status === "APPROVED" || showTakeAction === "Take_Action") && (
            <div style={{ marginLeft: "180px", marginTop: "20px" }}>
              <Button
                variant="contained"
                color="success"
                style={{ marginLeft: "10px" }}
                onClick={() => viewApprovalLetter(formData?.approvalLetterUrl)}
              >
                View Approval Letter
              </Button>
            </div>
          )} */}
        </React.Fragment>
      );
    } else if (activeTab === 4 && !isCitizen) {
      return (
        <React.Fragment>
          <AllRemarksList remarkDataResps={workflowDetails?.data} />
        </React.Fragment>
      );
    }
  };

  useEffect(() => {
    if (validUpTo !== undefined) setValidUpto(validUpTo);
  }, [validUpTo]);
  return (
    <MainWrapper>
      <BackButton />
      <FormStrip formName={t("Technical Professional Registration")} />
      <PrimaryTabsWrapper>
        {/* Tabs Header */}
        <PrimaryTabs value={activeTab} onChange={(e, i) => handleTabChange(i)} aria-label="Tab Group" variant="scrollable" scrollButtons="auto">
          <PrimaryTab label="Applicantion Form" />
          {!isCitizen && <PrimaryTab label="Document" />}
          {!isCitizen && <PrimaryTab label="Checklist" />}
          <PrimaryTab label="Take Action" />
          <PrimaryTab label="All Remarks" />
        </PrimaryTabs>
      </PrimaryTabsWrapper>
      <StyledDivider />
      {activeTab === 0 && (
        <SubTabsWrapper>
          <SubTabs
            value={selectedSubTab}
            onChange={(e, i) => handleSubTabChange(i)}
            aria-label="Sub Tab Group"
            variant="scrollable"
            scrollButtons="auto"
          >
            {subTabLabels.map((tab, index) => (
              <SubTab key={index} label={tab.label} />
            ))}
          </SubTabs>
        </SubTabsWrapper>
      )}
      {renderContent()}
      {/* {showToast && (
      <Toast error={showToast?.error} warning={showToast?.warning} label={t(showToast?.message)} onClose={closeToast} isDleteBtn={true} />
    )} */}
    </MainWrapper>
  );
};

export default EmpLtpPortal;
